import { render } from "./CRMWhatsappProductFollowupsView.vue?vue&type=template&id=4a5f3a94&scoped=true"
import script from "./CRMWhatsappProductFollowupsView.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappProductFollowupsView.vue?vue&type=script&lang=js"

import "./CRMWhatsappProductFollowupsView.vue?vue&type=style&index=0&id=4a5f3a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5f3a94"]])

export default __exports__